module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-02-en.37a6235dc4b3e26cfce5f063d6ac791b.png";